import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { TokenService } from '../services/secureTokenService';
import { authReadyGate } from '../services/authReadyGate';
import { LS_KEY_CURRENT_ACCOUNT_ID } from '../app/Slices/teamSlice';

/**
 * Returns a logout function that clears local state and redirects via Auth0.
 * @param returnTo - URL to redirect to after logout (defaults to window.location.origin)
 */
export const useLogout = (returnTo?: string) => {
  const { logout } = useAuth0();

  return useCallback(() => {
    localStorage.removeItem(LS_KEY_CURRENT_ACCOUNT_ID);
    TokenService.clearTokens();
    authReadyGate.reset();
    logout({
      logoutParams: {
        returnTo: returnTo ?? window.location.origin,
      },
    });
  }, [logout, returnTo]);
};
